import { QuotesReloadProps } from "models/Quote";
import { createActions, createReducer } from "reduxsauce";

export const { Types, Creators } = createActions({
  setQuoteItem: ['data']
});

const INITIAL_STATE: QuotesReloadProps = { id: "" };

const setQuoteItem = (state = INITIAL_STATE, action: any) => ({ ...action.data });

export default createReducer(INITIAL_STATE, {
  [Types.SET_QUOTE_ITEM as any]: setQuoteItem,
});
